import React, { useState, useEffect } from 'react';

/**
 * This file aims to implement a dynamic circular progressbar in order to
 * be called in PollRow javascript file for both Selected and Not Sellected radio buttons for Polls
 * @percentage is the percentage of the selected radio button for total users
 * @storkeColor is the color that will belong to the progress bar based on being selected or not
 */
const CircularProgressbar = ({ percentage, storkeColor }) => {
  const [animatedPercentage, setAnimatedPercentage] = useState(0);

  useEffect(() => {
    let interval;
    if (animatedPercentage <= percentage) {
      interval = setInterval(() => {
        setAnimatedPercentage((prevState) => prevState + 1);
      }, 25);
    }

    return () => clearInterval(interval);
  }, [animatedPercentage]);

  const radius = (50 - 10 / 2);
  const pathDescription = `
    M 50,50 m 0,-${radius}
    a ${radius},${radius} 0 1 1 0,${2 * radius}
    a ${radius},${radius} 0 1 1 0,-${2 * radius}
  `;

  const diameter = Math.PI * 2 * radius;
  const progressStyle = {
    stroke: storkeColor,
    strokeLinecap: 'round',
    strokeDasharray: `${diameter}px ${diameter}px`,
    strokeDashoffset: `${(((100 - animatedPercentage) / 100) * diameter)}px`,
  };

  return (
    <svg
      className="CircularProgressbar"
      viewBox="0 0 100 100"
      width={40}
      height={40}
    >
      <path
        className="CircularProgressbar-trail"
        d={pathDescription}
        strokeWidth={10}
        fillOpacity={0}
        style={{
          stroke: '#f0f0f0',
        }}
      />

      <path
        className="CircularProgressbar-path"
        d={pathDescription}
        strokeWidth={10}
        fillOpacity={0}
        style={progressStyle}
      />

      <text
        className="CircularProgressbar-text"
        x={50}
        y={50}
        style={{
          fill: 'black',
          fontSize: '25px',
          dominantBaseline: 'central',
          textAnchor: 'middle',
        }}
      >
        {`${animatedPercentage}%`}
      </text>
    </svg>
  );
};

export default CircularProgressbar;
